// extracted by mini-css-extract-plugin
module.exports = {"container":"error_container__6Ub9C","icon":"error_icon__VvtRD","errorcontainer":"error_errorcontainer__22ouH"};